module.exports = __webpack_public_path__ + "images/42d7d554130a007a49416329fab2d074.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/thesuperlatives-characters03.jpg
// module id = ./webpack/assets/img/thesuperlatives-characters03.jpg
// module chunks = 0